// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

import {getAuth, GoogleAuthProvider} from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAnnp6SVbwdFdMyf7k2A0Jv28qaJWGzrzM",
  authDomain: "chatapp-507b6.firebaseapp.com",
  projectId: "chatapp-507b6",
  storageBucket: "chatapp-507b6.firebasestorage.app",
  messagingSenderId: "595797872388",
  appId: "1:595797872388:web:ab6f93145a9a756f868a51",
  measurementId: "G-ZMCQFXWDPR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);